import { Component, input } from '@angular/core';
import { IHotlineAvailabilityResult } from 'src/models/app.model';

@Component({
  selector: 'liberro-hotline-availability',
  standalone: false,
  templateUrl: './liberro-hotline-availability.component.html',
  styleUrl: './liberro-hotline-availability.component.less'
})
export class LiberroHotlineAvailabilityComponent {
  public hotlineAvailability = input.required<IHotlineAvailabilityResult>();
}
